import { forwardRef, type AnchorHTMLAttributes } from "react";
import Icon, { type IconName, type IconStyle } from "@react/widget/Icon";
import clsx from 'clsx';
import styles from './Link.module.css';

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement|HTMLSpanElement> {
  displayStyle?: string;
  icon?: boolean | IconName;
  iconStyle?: IconStyle;
  iconPosition?: "left" | "right";
};

const Link = forwardRef<HTMLAnchorElement, Props>(({
  icon = false,
  iconStyle,
  iconPosition = "right",
  className,
  displayStyle = "inline-block",
  children,
  ...props
}, ref) => {
  const Tag = !!props?.href ? "a" : "span";
  const iconName:IconName = (typeof icon == "string") ? icon : "arrow-right-long";
  return (
    <Tag className={clsx(styles.link, className)} {...props} ref={ref}>
      { (!!icon && iconPosition === "left") && <Icon className={clsx(!!children && "mr-1")} style={iconStyle} name={iconName}/> }
      { !!children && (!!icon ? (<span>{children}</span>) : children) }
      { (!!icon && iconPosition === "right") && <Icon className={clsx(!!children && "ml-1")} style={iconStyle} name={iconName}/> }
    </Tag>
  )
});

export default Link;